import { TCityParam, TForm } from "@containers/LandingPage/type";
import { AxiosRequestConfig } from "axios";

const BASE_URL: string = process.env.NEXT_PUBLIC_BASE_URL as string;

const InterestFormServices = {
  PostInterestFormService: (
    data: Partial<TForm>,
    clientToken?: string,
    lang?: string
  ): AxiosRequestConfig => ({
    url: `${BASE_URL}/lead-management/lead/v1/all-source`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Basic ${process.env.NEXT_PUBLIC_BASIC_AUTH}`,
      ClientToken: clientToken || "",
      lang: lang || "",
    },
  }),
  GetIndustryService: (lang: string): AxiosRequestConfig => ({
    url: `${BASE_URL}/lead-management/general/v1/industry`,
    method: "GET",
    headers: {
      Authorization: `Basic ${process.env.NEXT_PUBLIC_BASIC_AUTH}`,
      lang: lang,
    },
  }),
  GetCountryService: (token: string): AxiosRequestConfig => ({
    url: `${BASE_URL}/users-management/v1/general/country`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }),
  GetCityService: (param: TCityParam): AxiosRequestConfig => ({
    url: `${BASE_URL}/lead-management/general/v1/search/city`,
    method: "GET",
    params: param,
    headers: {
      Authorization: `Basic ${process.env.NEXT_PUBLIC_BASIC_AUTH}`,
    },
  }),
  GetCompanySize: (lang: string): AxiosRequestConfig => ({
    url: `${BASE_URL}/lead-management/general/v1/company-size`,
    method: "GET",
    headers: {
      Authorization: `Basic ${process.env.NEXT_PUBLIC_BASIC_AUTH}`,
      lang: lang || "id",
    },
  }),
  PostEmailChecking: (
    payload: { email: string },
    token: string,
    clientToken?: string,
  ): AxiosRequestConfig => ({
    url: `${BASE_URL}/users-management/v1/general/email-check`,
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${token}`,
      ClientToken: clientToken || "",
    },
  }),
  PostSubmitEmailVerify: (
    payload: Partial<TForm>,
    token: string,
    clientToken?: string,
  ): AxiosRequestConfig => ({
    url: `${BASE_URL}/users-management/v1/general/email-verification-send`,
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${token}`,
      ClientToken: clientToken || "",
    },
  }),
  PostEmailVerification: (
    payload: { signatureCode: string | string[] | undefined },
    token: string,
    clientToken?: string,
  ): AxiosRequestConfig => ({
    url: `${BASE_URL}/users-management/v1/general/email-verification`,
    method: "POST",
    data: payload,
    headers: {
      Authorization: `Bearer ${token}`,
      ClientToken: clientToken || "",
    },
  }),
};

export default InterestFormServices;
